import MojitoCore from 'mojito/core';
import MainNavigationBarClassic from './classic/index.js';
import MainNavigationBarAvantgarde from './avantgarde/index.js';

const UIViewFamily = MojitoCore.Presentation.UIViewFamily;

/**
 * @namespace MainNavigationBar
 * @memberof Mojito.Applications.Sports
 */

/**
 * Main navigation bar offering the user to do overall application navigation. Renders
 * {@link Mojito.Applications.Sports.MainNavigationBarClassic|MainNavigationBarClassic} or
 * {@link Mojito.Applications.Sports.MainNavigationBarAvantgarde|MainNavigationBarAvantgarde}
 * depending on the active design style.
 *
 * @class MainNavigationBar
 * @memberof Mojito.Applications.Sports.MainNavigationBar
 */

export default UIViewFamily('MainNavigationBar', {
    classic: MainNavigationBarClassic,
    avantgarde: MainNavigationBarAvantgarde,
});
